function openInNewWindow(file: Blob | string, title?: string) {

  const fileUrl = file instanceof Blob 
    ? URL.createObjectURL(file)
    : file;
  const iframe = document.createElement('iframe');
  iframe.src = fileUrl;
  iframe.width = '100%';
  iframe.height = '100%';
  iframe.style.border = 'none';

  const newWindow = window.open('', '_blank');
  if (!newWindow) return;
  newWindow.document.body.appendChild(iframe);
  newWindow.document.title = title ?? "GeoConnect Document";
}

async function fullScreen(ref: HTMLDivElement | null) {
  if (ref && ref.requestFullscreen) {
    try {
      await ref.requestFullscreen();
    } catch (error) {
      console.error(error);
    }
  }
}

export { fullScreen, openInNewWindow };